export const REFERRAL_TRACE_GET_REQUEST = 'REFERRAL_TRACE_GET_REQUEST';
export const REFERRAL_TRACE_GET_SUCCESS = 'REFERRAL_TRACE_GET_SUCCESS';
export const REFERRAL_TRACE_GET_ERROR = 'REFERRAL_TRACE_GET_ERROR';
export const REFERRAL_TRACE_GET_BY_KEY_REQUEST = 'REFERRAL_TRACE_GET_BY_KEY_REQUEST';
export const REFERRAL_TRACE_GET_BY_KEY_SUCCESS = 'REFERRAL_TRACE_GET_BY_KEY_SUCCESS';
export const REFERRAL_TRACE_GET_BY_KEY_ERROR = 'REFERRAL_TRACE_GET_BY_KEY_ERROR';
export const REFERRAL_TRACE_ADD_REQUEST = 'REFERRAL_TRACE_ADD_REQUEST';
export const REFERRAL_TRACE_ADD_SUCCESS = 'REFERRAL_TRACE_ADD_SUCCESS';
export const REFERRAL_TRACE_ADD_ERROR = 'REFERRAL_TRACE_ADD_ERROR';
export const REFERRAL_TRACE_EDIT_REQUEST = 'REFERRAL_TRACE_EDIT_REQUEST';
export const REFERRAL_TRACE_EDIT_SUCCESS = 'REFERRAL_TRACE_EDIT_SUCCESS';
export const REFERRAL_TRACE_EDIT_ERROR = 'REFERRAL_TRACE_EDIT_ERROR';
export const REFERRAL_TRACE_DELETE_REQUEST = 'REFERRAL_TRACE_DELETE_REQUEST';
export const REFERRAL_TRACE_DELETE_SUCCESS = 'REFERRAL_TRACE_DELETE_SUCCESS';
export const REFERRAL_TRACE_DELETE_ERROR = 'REFERRAL_TRACE_DELETE_ERROR';
